<template>
    <div>
        <span class="letter-sizer" :key="i" v-for="(letter, i) in caption">
            <span class="letter">{{letter}}</span>
        </span>
    </div>
</template>

<script>
export default {
    props: ['caption']
}
</script>

<style lang="sass" scoped>
.letter-sizer
    display: inline-block
    position: relative
    @for $i from 0 through 30
        &:nth-child(#{$i + 1})
            .letter
                transition-delay: .05s * $i, .05s * $i
.letter
    white-space: pre
    display: block
    transition: transform .3s, opacity .3s
    will-change: transform, opacity
</style>
